import { render } from "./VehicleTabsComponent.vue?vue&type=template&id=06328598&scoped=true"
import script from "./VehicleTabsComponent.vue?vue&type=script&lang=js"
export * from "./VehicleTabsComponent.vue?vue&type=script&lang=js"

import "./VehicleTabsComponent.vue?vue&type=style&index=0&id=06328598&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06328598"]])

export default __exports__